var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.works.length ? _c('v-sheet', {
    staticClass: "mt-30 mt-md-40 mt-md-50"
  }, [_c('p', {
    staticClass: "font-size-md-42 font-size-36 line-height-1"
  }, [_vm._v("Artworks")]), _c('v-row', {
    staticClass: "mt-20 mt-md-30 mt-lg-40"
  }, [_vm._l(_vm.works, function (work) {
    return [_c('v-col', {
      key: work._id,
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c('author-view-works-item', _vm._b({}, 'author-view-works-item', {
      work: work
    }, false))], 1)];
  })], 2)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }